import styles from './CmsCalendar.module.scss';
import { Container, Heading } from '@wienenergiegithub/ui-next';
import React from 'react';
import { Day } from './components';
import PropTypes from 'prop-types';

const CmsCalendar = ({ days, isActive }) => {
  if (!isActive) {
    return (
      <Heading as="p" size="h1">
        Diese Aktion ist Abgelaufen
      </Heading>
    );
  }

  return (
    <Container className={styles.container}>
      {days.map(day => (
        <Day key={day.id} {...day} />
      ))}
    </Container>
  );
};

CmsCalendar.propTypes = {
  days: PropTypes.arrayOf(
    PropTypes.shape({
      dayNumber: PropTypes.string.isRequired,
      details: PropTypes.string,
      icon: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      modalImage: PropTypes.string,
      modalTitle: PropTypes.string,
      subtitle: PropTypes.string,
      status: PropTypes.oneOf(['upcoming', 'active', 'expired']).isRequired,
      unavailableCtaText: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
  isActive: PropTypes.bool,
};

export default CmsCalendar;
